import React from 'react'

import { Route, Switch } from 'react-router-dom'

import List from './List'
import Show from './Show'

export default () => (
  <Switch>
    <Route path="/notifications" exact component={List} />
    <Route path="/notifications/:id" exact component={Show} />
  </Switch>
)
